import { BrowserRouter } from "react-router-dom";
import AppLayout from "./AppLayout";

function App({ initialAuth = null }) {
  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <AppLayout initialAuth={initialAuth} />
    </BrowserRouter>
  );
}

export default App;
